import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { userGroups } from "@/endpoints/dryp/userGroups";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { Loader2 } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useParams } from "react-router";
import { EditForm } from "./EditForm";

export const EditUserGroup = observer(() => {
	const userGroupsApi = useAsyncStateStore(userGroups.getUserGroups);

	const { userGroupId } = useParams();

	useEffect(() => {
		userGroupsApi.fetch();
	}, [userGroupsApi]);

	const userGroup = userGroupsApi.data?.find(({ IdUserGroup }) => IdUserGroup.toString() === userGroupId);

	if (userGroupsApi.loading) {
		return (
			<Card className="m-4 w-1/3">
				<CardContent>
					<div className="flex justify-center">
						<Loader2 color="white" className="animate-spin" size={48} />
					</div>
				</CardContent>
			</Card>
		);
	}

	if (userGroupsApi.success && userGroup) {
		return <EditForm userGroup={userGroup} />;
	} else {
		return (
			<Card className="m-4 w-1/3">
				<CardHeader>
					<CardTitle>Unknonw error</CardTitle>
				</CardHeader>
			</Card>
		);
	}
});
